import React, { Fragment } from 'react'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: 'px solid #000',
    boxShadow: 24,
    p: 4,
    color: 'black'
};

const DiaModalComponent = (props) => {

    const { show, onHide, info } = props


    /******Modal */
    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={show}
                    onClose={onHide}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "#F30707" }}>
                            <center><strong>VISITA</strong></center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black" }}>
                            {JSON.stringify(info)}
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-success'>COMENZAR VISITA</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }

    return (
        <Fragment>
            {modalComponent()}
        </Fragment>
    )
}

export default DiaModalComponent